var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
typeof window !== 'undefined' &&
    !window.__DS_WEB_VERSION__ &&
    (window.__DS_WEB_VERSION__ = '2.4.0');
import * as Styles from './styles';
/**
 * Componente Badge do Design System OLX
 */
export const Badge = (_a) => {
    var { dsParentName } = _a, props = __rest(_a, ["dsParentName"]);
    const customColors = props.customColor
        ? {
            color: props.customColor.textColor || '',
            backgroundColor: props.customColor.backgroundColor || '',
        }
        : {};
    return (React.createElement(Styles.BadgeWrapper, { "data-ds-component": dsParentName ? `DS-${dsParentName}-Badge` : 'DS-Badge', role: "status", className: props.color || 'info', "aria-label": props['aria-label'], style: customColors }, props.children));
};
Badge.displayName = 'Badge';
